export const partOfString = (str: string, start: number, end: number) => str.split('').reduce((acc, curr, i) => acc + ((i >= start && i <= end) ? curr : ''), '');
